import React from "react";
import "./Terms.css";
import {Helmet} from "react-helmet";
const Terms = () => {
  return (
    <div className="terms-container">
      <Helmet>
                <meta charSet="utf-8" />
                <title>Terms and Conditions - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
      <h1 className="terms-title">Terms and Conditions</h1>
      <p className="terms-text">
        Welcome to Otter Tutors. By accessing or using our tutoring services, you agree to be bound by the following terms and conditions. Please read these terms carefully. If you do not agree to any of these terms, you should not use our services.
      </p>

      <h2 className="terms-subtitle">Services Offered</h2>
      <p className="terms-text">
        Otter Tutors provides educational services through online tutoring. Classes are scheduled based on tutor availability and student requirements.
      </p>

      <h2 className="terms-subtitle">Enrollment and Registration</h2>
      <ul className="terms-list">
        <li>Parents or guardians must complete the registration process for minors.</li>
        <li>Upon successful registration, students will be assigned to their respective batches.</li>
        <li>All personal information provided must be accurate and up-to-date.</li>
      </ul>

      <h2 className="terms-subtitle">Fees and Payments</h2>
      <ul className="terms-list">
        <li>Tuition fees are to be paid in total for 6 months, as per the fee structure communicated during registration.</li>
        <li>All payments must be made through the designated payment methods.</li>
      </ul>

      <h2 className="terms-subtitle">Class Schedule and Cancellations</h2>
      <ul className="terms-list">
        <li>Classes are scheduled regularly 6 days a week.</li>
        <li>Any changes in schedule or class cancellations will be communicated in the batch notification section.</li>
        <li>
          If a class is missed by the student, a make-up class is not guaranteed unless prior notice is given, and the reason is deemed valid by Otter Tutors.
        </li>
      </ul>

      <h2 className="terms-subtitle">Responsibilities of Students and Parents</h2>
      <ul className="terms-list">
        <li>Students are expected to attend all scheduled classes punctually and be prepared with necessary materials.</li>
        <li>Parents/guardians are responsible for ensuring their child’s participation and adherence to the schedule.</li>
        <li>Disruptive behavior during classes may lead to temporary or permanent removal from the class.</li>
      </ul>

      <h2 className="terms-subtitle">Tutor Assignment</h2>
      <p className="terms-text">
        Tutors are assigned based on subject expertise and availability. Otter Tutors reserves the right to change the assigned tutor for any batch or subject at its discretion.
      </p>

      <h2 className="terms-subtitle">Code of Conduct</h2>
      <ul className="terms-list">
        <li>Students must maintain respectful communication with tutors and other classmates.</li>
        <li>Any form of cheating, plagiarism, or misconduct during lessons or assessments is strictly prohibited.</li>
      </ul>
    </div>
  );
};

export default Terms;
